import { RootState } from '../store';
import { ProductState } from './products.slice';

export const selectProductsState = (state: RootState): ProductState => state.products;
